export default el => {
    if(!el.slug || !el.slug.current) {
        return el._id
    }

    return el.slug.current
}